import { useCallback, useEffect, useState } from "react";
//#region src/graphql.ts
var useGraphqlQuery = (client, query, vars) => {
	const queryFn = useCallback(() => client.query(query, vars), [client, JSON.stringify({
		query,
		vars
	})]);
	const [runQuery, setRunQuery] = useState(true);
	const [fetchState, setFetchState] = useState({
		loading: true,
		error: void 0,
		data: void 0
	});
	const refreshFn = useCallback(() => setRunQuery(true), []);
	useEffect(() => {
		if (!runQuery) return;
		let unmounted = false;
		async function execute() {
			try {
				const result = await queryFn();
				if (!unmounted) setFetchState({
					loading: false,
					data: result.data,
					error: result.error
				});
			} catch (e) {
				if (!unmounted) setFetchState({
					loading: false,
					data: void 0,
					error: e
				});
			} finally {
				if (!unmounted) setRunQuery(false);
			}
		}
		execute();
		return () => {
			unmounted = true;
		};
	}, [runQuery, queryFn]);
	return {
		...fetchState,
		refresh: refreshFn
	};
};
//#endregion
export { useGraphqlQuery };

